/**
 * Sticker — élément central du langage PASSAGE.
 *
 * Petit pill légèrement roté, fond coloré, bordure noire 2px, ombre dure
 * noire offset (pas de blur). À utiliser pour : badges de section, chips
 * "feature", étiquettes flottantes autour du phone mockup, statuts.
 */
import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

export type StickerColor =
  | 'tomate' | 'beurre' | 'menthe' | 'outre' | 'bordeaux' | 'peach' | 'cream' | 'ink';

const BG: Record<StickerColor, string> = {
  tomate:   'bg-passage-tomate text-white',
  beurre:   'bg-passage-beurre text-passage-ink',
  menthe:   'bg-passage-menthe text-passage-ink',
  outre:    'bg-passage-outre text-white',
  bordeaux: 'bg-passage-bordeaux text-white',
  peach:    'bg-passage-peach text-passage-ink',
  cream:    'bg-passage-cream text-passage-ink',
  ink:      'bg-passage-ink text-white',
};

export interface StickerProps {
  color?: StickerColor;
  rotate?: number;
  shadow?: 'xs' | 'sm' | 'md';
  className?: string;
  children: ReactNode;
}

const SHADOW: Record<NonNullable<StickerProps['shadow']>, string> = {
  xs: 'shadow-passage-xs',
  sm: 'shadow-passage-sm',
  md: 'shadow-passage',
};

export function Sticker({
  color = 'beurre',
  rotate = -3,
  shadow = 'sm',
  className,
  children,
}: StickerProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full px-3 py-1.5',
        'border-2 border-passage-ink text-xs font-bold',
        BG[color],
        SHADOW[shadow],
        className,
      )}
      style={{ transform: `rotate(${rotate}deg)` }}
    >
      {children}
    </span>
  );
}
